const BaseComponent = require('base/base-component');
const { formatDate: toDate } = require('helper/util');
const Query = require('helper/query');
const ESClient = require('helper/es-client');

const listTpl = Handlebars.templates['cpa/fullTextSearch/templates/listTpl'];
class fullTextSearch extends BaseComponent {
  constructor () {
    super({
      events: {
        'click .Jtimeframe': 'fuzzyTime',
        'click .Jmodule': 'changeModule',
        'click .Jtype': 'changeType',
        'change .startTime': 'changeDate',
        'change .endTime': 'changeDate'
      }
    });
  }
  init () {
    this.$startTime = this.$el.find('.startTime');
    this.$endTime = this.$el.find('.endTime');
    this.$date = this.$el.find('.date');
    this.$m = this.$el.find('.conditionwrap .Jmodule');
    this.$pageContainer = this.$el.find('.page');
    this.$pageAbove = this.$el.find('.pagination-list-above');
    this.$pageBelow = this.$el.find('.pagination-list-below');
    this.$key = this.$el.find('.content .key');
    this.$count = this.$el.find('.content .search-total');
    this.$start = this.$el.find('.content .start');
    this.$end = this.$el.find('.content .end');
    this.$search_body = this.$el.find('.f_body');
    this.$timeFrame = this.$el.find('.Jtimeframe');

    this.client = new ESClient();

    this._d = new Date().getTime();
    this._ndate = this._d - (3 * 24 * 60 * 60 * 1000);
    this.pageNo = 1; // 记录当前pageNo
    /**
     * 初始化开始时间和结束时间
     */
    this.$startTime.val(toDate(this._ndate));
    this.$endTime.val(toDate(this._d));
    /**
     * 日期选择器
     */
    this.$date.datetimepicker({
      format: 'yyyy-mm-dd',
      autoclose: true,
      maxView: 4,
      minView: 2,
      endDate: toDate(new Date().getTime()),
      language: 'zh-CN'
    });

    this.query = new Query();
    this.$m.eq(0).trigger('click');

    // 监听来自header组件的搜索事件
    $(window).on('fulltextSearch.ZCY', (e, keyword) => {
      this.search(true, keyword);
    });
  }

  /**
     * 分页
     * @param count
     * @param wrap
     */
  initPagination (count, wrap) {
    const that = this;
    let sources = (function () {
      let result = [];
      for (let i = 0; i < count; i++) {
        result.push(i);
      }
      return result;
    })();

    const options = {
      dataSource: sources,
      totalNumber: count,
      pageSize: 15,
      pageNumber: that.pageNo,
      prevText: '上一页',
      nextText: '下一页',
      showGoInput: false,
      showGoButton: false,
      beforeGoButtonOnClick: (event, pageNumber) => {
        that.pageNo = pageNumber;
        that.search();
      },
      beforePageOnClick: (event, pageNumber) => {
        that.pageNo = pageNumber;
        that.search();
      },
      beforePreviousOnClick: () => {
        that.pageNo--;
        that.search();
      },
      beforeNextOnClick: () => {
        that.pageNo++;
        that.search();
      }
    };
    wrap.pagination(options);
  }

  shapeShow (e) {
    const $ele = $(e.target || e.srcElement);
    if ($ele.val().length > 0) {
      this.$el.find('.icon-Shape').show();
    } else {
      this.$el.find('.icon-Shape').hide();
    }
  }

  changeModule (e) {
    const el = e.target || e.srcElement;
    $(el).addClass('selected').siblings()
      .removeClass('selected');
    const childInfo = $(el).data('children');
    const code = $(el).data('num');
    if (childInfo && childInfo.length > 0) {
      const $indexTypeBox = this.$el.find('.typebox').filter(`[data-code=${code}]`);
      $indexTypeBox.find('.right span')
        .eq(0)
        .addClass('selected')
        .siblings()
        .removeClass('selected');
      $indexTypeBox.show()
        .siblings('.typebox')
        .hide();
    } else {
      this.$el.find('.typebox').hide();
    }
    this.search(true);
  }
  changeType (e) {
    const el = e.target || e.srcElement;
    // const index = $(el).index();
    $(el).addClass('selected').siblings()
      .removeClass('selected');

    this.search(true);
  }

  changeDate () {
    this.$timeFrame.removeClass('selected');
    this.search(true);
  }

  /**
   * 搜索
   * @param isRefresh 是否刷新分页
   */
  search (isRefresh, key) {
    key !== undefined && this.query.set('k', key);
    const that = this;
    const module = that.$m.filter('.selected').data('num');
    const type = that.$el.find('.typebox:visible .right').find('.selected').data('num');
    const begin = that.$startTime.val();
    const end = that.$endTime.val();
    const keyword = this.query.get('k') || '';
    that.$key.text(keyword || '');
    that.$start.text(begin);
    that.$end.text(end);
    let requestData = {
      pageNo: isRefresh ? 1 : that.pageNo,
      pageSize: 15,
      keyword,
      begin: Date.parse(begin) - (8 * 60 * 60 * 1000),
      end: Date.parse(end) + ((16 * 60 * 60 * 1000) - 1),
      firstCode: module,
      secondCode: type
    };
    for (let k in requestData) {
      if (requestData[k] === '' || requestData[k] === null || requestData[k] === undefined) {
        delete requestData[k];
      }
    }

    this.client
      .searchArticle(requestData)
      .then((res) => {
        const total = res.hits.total;
        that.$count.text(total);
        if (total > 0) {
          that.$pageContainer.show();
          that.initPagination(total, that.$pageAbove);
          that.initPagination(total, that.$pageBelow);
          that.$pageContainer
            .find('.J-paginationjs-page:last')
            .css('borderRight", "1px solid #D8D8D8');
        } else if (total <= 0) {
          that.$pageContainer.hide();
        }
        that.$search_body.html(listTpl({ _DATA_: res.hits }));
      });
  }


  /**
     * 时间模糊选择
     * @param e
     */
  fuzzyTime (e) {
    const that = this;
    const el = e.target || e.srcElement;
    $(el).addClass('selected').siblings()
      .removeClass('selected');
    const _w = $(el).data('num');
    const _d = new Date().getTime();
    let newDate = '';
    if (_w.indexOf('m') >= 0) {
      const p = _w.substring(0, 1);
      newDate = that.date(toDate(_d), p);
    } else {
      const _p = _w.substring(0, 1);
      const _ndate = _d - (_p * 24 * 60 * 60 * 1000);
      newDate = toDate(_ndate);
    }
    that.$startTime.val(newDate);
    that.$endTime.val(toDate(_d));
    that.search(true);
  }
  /* eslint-disable */
  date (_date, p) {
    const that = this;
    const _timeArr = (_date).split('-');
    let year = _timeArr[0];
    let month = _timeArr[1];
    let date = _timeArr[2];
    if (month - p <= 0) {
      month = 12 + parseInt(month) - p;
      year--;
    } else {
      month -= p;
    }
    const tempdate = `${year}-${month}-${date}`;
    return that.judgeDate(tempdate);
  }
  judgeDate (datetemp) {
    const _dArr = datetemp.split('-');
    let year = _dArr[0];
    let month = _dArr[1];
    let date = _dArr[2];
    const isLeap = (year % 4 == 0) && (year % 100 != 0 || year % 400 == 0);
    if (month == 2) {
      date = date > 29 ? isLeap ? 29 : 28 : date;
    } else if (month == 4 || month == 6 || month == 9 || month == 11) {
      date = date > 30 ? 30 : date;
    } else {
      date = date;
    }
    month = month > 9 ? month:`0${month}`;
    // date = date>9?date:`0${date}`
    return `${year}-${month}-${date}`;
  }


}
module.exports = fullTextSearch;
